import React from "react";
import { Helmet } from "react-helmet";

export default function About() {
  return (
    <div>
      <Helmet>
        <title>About Us || TamizhTechie</title>
        <meta name="description" content="About Us" />
      </Helmet>
      <div className="aboutus">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1>THE MOTTO</h1>
              <h2>“தொழில்நுட்பங்களின் நுட்பங்களை தேடி ஒரு தேடல்”</h2>
              <h6>Intro :</h6>
              <p>
                We show our gratitude to all of you for spotting us at the
                corner of the internet .We aimed at sharing the insights of
                technology in our mother tongue to the readers .
              </p>
              <h6>The basis:</h6>
              <p>
                {" "}
                Technology is the forefront thing in this modern world. Each and
                everyone must know about technical things . When comes of
                technology , it owes a high language . The biggest obstruct for
                most of the people is the language .To this obstruct we’ve
                designed this website where a Tamilian can search technology in
                his mother tongue.
              </p>
              <h6>We give you the expertise on :</h6>
              <ul>
                <li>Trending updates – upto date technology related news </li>
                <li>
                  Gadget updates – about arrival of new products in the market{" "}
                </li>
                <li>Techi talks – defines technical stuffs </li>
              </ul>
              <h6>The team : </h6>
              <p>
                {" "}
                We aren’t a truckload of people .We a team of two have worked
                hard on this site .{" "}
              </p>
              <h5>
                <a target="_blank" href="https://babz-balaji.web.app/">
                  BALAJI
                </a>
                , Founder
              </h5>

              <p>
                {" "}
                If you find our website ease to use the brownie points should be
                given to Balaji . Being an innovative thinker and a skilful
                developer and has a sublime quality in web development , UI/UX
                designing , graphic designing , digital marketing Balaji has
                designed this website{" "}
              </p>
              <h5>
                {" "}
                <a
                  target="_blank"
                  href="https://www.linkedin.com/in/rakshana-s/"
                >
                  RAKSHANA
                </a>
                , Co-Founder
              </h5>
              <p>
                {" "}
                Master in computer science yet choose to concoct in tamizhtechie
                as a content creator . If the contents in tamizhtechie is
                preferable then the credits should be given to Rakshana{" "}
              </p>
              <h6>Conclusion :</h6>
              <p>
                All together we have designed this website in our mother tongue
                to break the myth that technology is all about computer and
                communication . And to make everyone understand technology in a
                simple manner .{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
